<template>
  <div>
    <sw-search
      :placeholder="'请输入用户名/组织机构'"
      style="max-width: 300px;margin-top:10px"
      @search="searchHandle"
    />
    <sw-table
      v-loading="loading"
      :show-selection="false"
      :page-sizes="[10]"
      :total-count="totalCount"
      :page-size="pageSize"
      :table-data="tableData"
      :table-title="tableTitle"
      :has-operation="false"
      :has-add-button="false"
      :page-layout="'prev, pager, next, jumper, ->'"
      style="margin-top: 10px"
      @change-page="changePage"
      @next-page="changePage"
      @prev-page="changePage"
    >
      <template
        slot="customcolumn"
        slot-scope="scope"
      >
        <span v-if="scope.item.prop=='radio'">
          <el-radio
            v-model="radio"
            :label="scope.row.radio"
            @change="getRow(scope.row)"
          >{{ '' }}</el-radio>
        </span>
        <span
          v-else
          :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
          class="swTableCell"
        >{{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}</span>
      </template>
    </sw-table>
  </div>
</template>

<script>
import { GET_NEW_USER_LIST, GET_USER_LIST_TOTAL } from '@/api'
export default {
  data () {
    return {
      radio: '',
      loading: false,
      totalCount: 0,
      page: 1,
      pageSize: 10,
      searchValue: '',
      tableData: [],
      tableTitle: [
        { prop: 'radio', label: '', width: '60' },
        { prop: 'username', label: '工号', width: '120', sortable: false },
        { prop: 'realName', label: '姓名', width: '120', sortable: false },
        { prop: 'organizationName', label: '组织机构', width: '120', sortable: false }
      ],
      selectedRow: {}
    }
  },
  async created () {
    await this.getUserTotal()
    this.changePage(1)
  },
  methods: {
    getData () {
      this.getUserList()
    },
    getUserList () {
      this.loading = true
      const obj = {
        keyword: this.searchValue,
        pageNum: this.page,
        pageSize: this.pageSize
      }
      GET_NEW_USER_LIST(obj).then(res => {
        this.radio = ''
        this.loading = false
        this.tableData = res.data.map((item, index) => {
          return {
            username: item.accountName,
            realName: item.name,
            organizationName: item.organizationName,
            radio: this.page + '' + index,
            id: item.id
          }
        })
      })
    },
    async getUserTotal () {
      const obj = {
        keyword: this.searchValue
      }
      await GET_USER_LIST_TOTAL(obj).then(res => {
        this.totalCount = res.data.totalCount
      })
    },
    changePage (page) {
      this.page = page
      this.getData()
    },
    getRow (row) {
      this.selectedRow = row
      this.$emit('change', row)
    },
    async searchHandle (value) {
      this.searchValue = value
      this.page = 1
      await this.getUserTotal()
      this.getData()
    }
  }
}
</script>

<style lang="scss">
</style>
